import { IValidatedFilter } from "./interfaces";

export const refreshFilters = (filters, onApplyFilters, togglePopup, additionalParams) => {
    const validatedFilters: IValidatedFilter[] = filters.filter((filter) =>
        filter.filterField &&
        filter.filterField.trim().length > 0 &&
        filter.filterType &&
        filter.filterType.trim().length > 0 &&
        filter.value &&
        typeof filter.value == "string"
            ? filter.value.trim().length > 0
            : filter.value
    ) as IValidatedFilter[];

    onApplyFilters(validatedFilters, additionalParams);

    togglePopup(false);
};
